Vue.config.productionTip = false;

var getUrl = function (relativePath) {
    return applicationPath + relativePath;
};

var getCobrandedUrl = function (relativePath) {
    return cobrandPath + relativePath;
};

var getSearchViewModelCopy = function () { return _.cloneDeep(searchViewModel); };

// credits https://stackoverflow.com/questions/2685911/is-there-a-way-to-round-numbers-into-a-reader-friendly-format-e-g-1-1k
var formatPrice = function (price, decimalPlaces) {
    if (decimalPlaces === undefined) decimalPlaces = 2;
    // 2 decimal places => 100, 3 => 1000, etc
    decimalPlaces = Math.pow(10, decimalPlaces);

    // Enumerate number abbreviations
    var abbrev = ['K', 'M', 'B', 'T'];

    // Go through the array backwards, so we do the largest first
    for (var i = abbrev.length - 1; i >= 0; i--) {

        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);

        // If the number is bigger or equal do the abbreviation
        if (size <= price) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            price = Math.round(price * decimalPlaces / size) / decimalPlaces;

            // Handle special case where we round up to the next abbreviation
            if (price === 1000 && i < abbrev.length - 1) {
                price = 1;
                i++;
            }

            // Add the letter for the abbreviation
            price += abbrev[i];

            // We are done... stop
            break;
        }
    }
    return price;
};

Vue.filter('money', function (val, decimalPlaces, symbol) {
    if (symbol === undefined) symbol = '£';
    if (decimalPlaces === undefined) decimalPlaces = 2;
    return symbol + val.toFixed(decimalPlaces);
});

Vue.filter('formatPrice', formatPrice);
